/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";

/**
 *
 * @export
 * @interface CompanyQuoteReportLine
 */
export interface CompanyQuoteReportLine {
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  pickupDate: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyQuoteReportLine
   */
  booked: boolean;
  /**
   *
   * @type {ShipmentState}
   * @memberof CompanyQuoteReportLine
   */
  status: ShipmentState;
  /**
   *
   * @type {number}
   * @memberof CompanyQuoteReportLine
   */
  numberQuotes: number;
  /**
   *
   * @type {number}
   * @memberof CompanyQuoteReportLine
   */
  numberBooked: number;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  pickupCity: string;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  pickupStateOrProvince: string;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  pickupPostalCode: string;
  /**
   *
   * @type {CountryCode}
   * @memberof CompanyQuoteReportLine
   */
  pickupCountryCode: CountryCode;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  deliveryCity: string;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  deliveryStateOrProvince: string;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  deliveryPostalCode: string;
  /**
   *
   * @type {CountryCode}
   * @memberof CompanyQuoteReportLine
   */
  deliveryCountryCode: CountryCode;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  weightDescription: string;
  /**
   *
   * @type {string}
   * @memberof CompanyQuoteReportLine
   */
  shipmentHash: string;
}

/**
 * Check if a given object implements the CompanyQuoteReportLine interface.
 */
export function instanceOfCompanyQuoteReportLine(
  value: object,
): value is CompanyQuoteReportLine {
  if (!("pickupDate" in value) || value["pickupDate"] === undefined)
    return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("numberQuotes" in value) || value["numberQuotes"] === undefined)
    return false;
  if (!("numberBooked" in value) || value["numberBooked"] === undefined)
    return false;
  if (!("pickupCity" in value) || value["pickupCity"] === undefined)
    return false;
  if (
    !("pickupStateOrProvince" in value) ||
    value["pickupStateOrProvince"] === undefined
  )
    return false;
  if (!("pickupPostalCode" in value) || value["pickupPostalCode"] === undefined)
    return false;
  if (
    !("pickupCountryCode" in value) ||
    value["pickupCountryCode"] === undefined
  )
    return false;
  if (!("deliveryCity" in value) || value["deliveryCity"] === undefined)
    return false;
  if (
    !("deliveryStateOrProvince" in value) ||
    value["deliveryStateOrProvince"] === undefined
  )
    return false;
  if (
    !("deliveryPostalCode" in value) ||
    value["deliveryPostalCode"] === undefined
  )
    return false;
  if (
    !("deliveryCountryCode" in value) ||
    value["deliveryCountryCode"] === undefined
  )
    return false;
  if (
    !("weightDescription" in value) ||
    value["weightDescription"] === undefined
  )
    return false;
  if (!("shipmentHash" in value) || value["shipmentHash"] === undefined)
    return false;
  return true;
}

export function CompanyQuoteReportLineFromJSON(
  json: any,
): CompanyQuoteReportLine {
  return CompanyQuoteReportLineFromJSONTyped(json, false);
}

export function CompanyQuoteReportLineFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyQuoteReportLine {
  if (json == null) {
    return json;
  }
  return {
    pickupDate: json["pickupDate"],
    booked: json["booked"],
    status: ShipmentStateFromJSON(json["status"]),
    numberQuotes: json["numberQuotes"],
    numberBooked: json["numberBooked"],
    pickupCity: json["pickupCity"],
    pickupStateOrProvince: json["pickupStateOrProvince"],
    pickupPostalCode: json["pickupPostalCode"],
    pickupCountryCode: CountryCodeFromJSON(json["pickupCountryCode"]),
    deliveryCity: json["deliveryCity"],
    deliveryStateOrProvince: json["deliveryStateOrProvince"],
    deliveryPostalCode: json["deliveryPostalCode"],
    deliveryCountryCode: CountryCodeFromJSON(json["deliveryCountryCode"]),
    weightDescription: json["weightDescription"],
    shipmentHash: json["shipmentHash"],
  };
}

export function CompanyQuoteReportLineToJSON(
  json: any,
): CompanyQuoteReportLine {
  return CompanyQuoteReportLineToJSONTyped(json, false);
}

export function CompanyQuoteReportLineToJSONTyped(
  value?: CompanyQuoteReportLine | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pickupDate: value["pickupDate"],
    booked: value["booked"],
    status: ShipmentStateToJSON(value["status"]),
    numberQuotes: value["numberQuotes"],
    numberBooked: value["numberBooked"],
    pickupCity: value["pickupCity"],
    pickupStateOrProvince: value["pickupStateOrProvince"],
    pickupPostalCode: value["pickupPostalCode"],
    pickupCountryCode: CountryCodeToJSON(value["pickupCountryCode"]),
    deliveryCity: value["deliveryCity"],
    deliveryStateOrProvince: value["deliveryStateOrProvince"],
    deliveryPostalCode: value["deliveryPostalCode"],
    deliveryCountryCode: CountryCodeToJSON(value["deliveryCountryCode"]),
    weightDescription: value["weightDescription"],
    shipmentHash: value["shipmentHash"],
  };
}
